/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskForeignAddress
 */
export interface ExecRiskForeignAddress {
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForeignAddress
     */
    address_line_1_txt?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForeignAddress
     */
    address_line_2_txt?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForeignAddress
     */
    city_nm?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForeignAddress
     */
    province_or_state_nm?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForeignAddress
     */
    country_cd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForeignAddress
     */
    foreign_postal_cd?: string;
}

/**
 * Check if a given object implements the ExecRiskForeignAddress interface.
 */
export function instanceOfExecRiskForeignAddress(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskForeignAddressFromJSON(json: any): ExecRiskForeignAddress {
    return ExecRiskForeignAddressFromJSONTyped(json, false);
}

export function ExecRiskForeignAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskForeignAddress {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'address_line_1_txt': !exists(json, 'address_line_1_txt') ? undefined : json['address_line_1_txt'],
        'address_line_2_txt': !exists(json, 'address_line_2_txt') ? undefined : json['address_line_2_txt'],
        'city_nm': !exists(json, 'city_nm') ? undefined : json['city_nm'],
        'province_or_state_nm': !exists(json, 'province_or_state_nm') ? undefined : json['province_or_state_nm'],
        'country_cd': !exists(json, 'country_cd') ? undefined : json['country_cd'],
        'foreign_postal_cd': !exists(json, 'foreign_postal_cd') ? undefined : json['foreign_postal_cd'],
    };
}

export function ExecRiskForeignAddressToJSON(value?: ExecRiskForeignAddress | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'address_line_1_txt': value.address_line_1_txt,
        'address_line_2_txt': value.address_line_2_txt,
        'city_nm': value.city_nm,
        'province_or_state_nm': value.province_or_state_nm,
        'country_cd': value.country_cd,
        'foreign_postal_cd': value.foreign_postal_cd,
    };
}

